const resources = {
    linkLead: 'Hautement évalué par les clients pour :'
};

module.exports = function getResource(label) {
    return resources[label];
};

